import moment from 'moment';
import 'moment/locale/pt-br';

export const formatDateRange = (isoDate?: string) => {
  if (!isoDate) return '';
  const m = moment(isoDate);
  const day = m.format('D');
  const month = m.format('MMM');
  const year = m.format('YYYY');
  const monthTitle = month.charAt(0).toUpperCase() + month.slice(1);
  return `${day} ${monthTitle} ${year}`;
};
